import type {
  MyPerformanceParams,
  MyPerformanceResponse,
} from './types/my-performance'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const myPerformanceApi = defineApi('operation', ({ prefix }) => {
  /**
   * 我的绩效
   * POST /gobestads/operation/adsPerformance/result/myPerf
   */
  function getMyPerformance(params: MyPerformanceParams) {
    return requestClient
      .post<MyPerformanceResponse>(prefix('adsPerformance/result/myPerf'), {
        quarter: params.quarter,
      })
      .then((res) => {
        const data = (res as MyPerformanceResponse) || {
          estimatedCoef: 0,
          indicators: [],
        }
        return {
          estimatedCoef: Number(data.estimatedCoef ?? 0),
          indicators:
            data.indicators?.map((item) => ({
              completion: Number(item.completion ?? 0),
              currentValue: Number(item.currentValue ?? 0),
              indicatorId: item.indicatorId ?? '',
              indicatorName: item.indicatorName || '-',
              progressDeviation: Number(item.progressDeviation ?? 0),
              targetValue: Number(item.targetValue ?? 0),
              weight: Number(item.weight ?? 0),
            })) || [],
        }
      })
  }

  return {
    getMyPerformance,
  }
})
